export enum CurrencyCode {
    CHF = 'CHF',
    EUR = 'EUR',
    USD = 'USD',
}
